const services = {
  header: {
    create: 'Create',
  },
  toast: {
    error: {
      badResponse: '[Service] bad server response',
      create: {},
      edit: {},
    },
    success: {
      create: {
        body: 'Service Has Been Added Successfully',
      },
      delete: {
        body: 'Services were deleted successfully',
      },
      edit: {},
    },
  },
  headerButtons: {
    create: 'New',
    delete: 'Delete',
  },
  table: {
    actions: {
      delete: 'Delete',
      export: 'Export',
    },
    headers: {
      maxPassengers: 'Max Passengers',
      sharedWith: 'Shared With',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },
  create: {
    errorToast: {
      message: 'Error Occurred. Could Not Create Service',
    },
    successToast: {
      message: 'Success! Service Created Successfully',
    },
  },

  edit: {
    errorToast: {
      message: 'Error Occurred. Could Not Update Service',
    },
    successToast: {
      message: 'Success! Service Updated Successfully',
    },
  },

  delete: {
    errorToast: {
      message: 'Error Occurred. Could Not Delete Service',
    },
    successToast: {
      message: 'Success! Service Has Been Deleted Successfully',
    },
  },

  forms: {
    header: {
      createService: {
        title: 'Create',
      },

      updateService: {
        title: 'Update',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Submit',
        update: 'Submit',
      },
    },

    information: {
      details: {
        header: 'Details',
        fields: {
          name: 'Name',
          type: 'Type',
          maxPassengers: 'Max Passengers',
          shared: 'Shared With',
          availableCount: 'Number of Vehicles',
          penaltyScore: {
            title: 'Penalty Score',
            description: 'Vehicle lease expense compared to extra route duration, measured in minutes.',
          }
        },
      },
      actions: {
        header: 'Actions',
        buttons: {
          delete: 'Delete',
          resetPassword: 'Reset Password',
        },
      },
    },
  },

  serviceTypes: {
    private: 'Private',
    shared: 'Shared',
  },

  deleteModal: {
    header: 'Delete Services',
    body: 'You are about to delete {{num}} services.',
  },
};

export default services;
